import React, { ReactElement, useEffect, useState } from 'react';
import {
    Alert,
    Button,
    Form,
    Input,
    Select,
    Space,
    Typography,
    message,
} from 'antd';
import { useAppDispatch } from 'store';
import { bulkCreateAdminUsers } from 'store/slices/adminUsersSlice';
import * as adminApi from 'js/utils/adminApi';
import { UserCreatePayload } from 'js/utils/adminApi';
import { IEvent } from 'store/slices/types';

const { Title, Paragraph } = Typography;
const { TextArea } = Input;

export default function BulkUploadPage(): ReactElement {
    const dispatch = useAppDispatch();
    const [events, setEvents] = useState<IEvent[]>([]);
    const [eventId, setEventId] = useState<number | null>(null);
    const [raw, setRaw] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState<{ ok: number; fail: number } | null>(
        null
    );

    useEffect(() => {
        adminApi.listEvents().then(list => {
            setEvents(list);
            if (list.length && eventId === null) setEventId(list[0].id);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmit = async (): Promise<void> => {
        if (!eventId) {
            message.error('Выбери event');
            return;
        }
        const urls = raw
            .split('\n')
            .map(s => s.trim())
            .filter(Boolean);
        if (!urls.length) {
            message.error('Ни одной ссылки');
            return;
        }
        const payload: UserCreatePayload[] = urls.map(url => ({
            url,
            // eslint-disable-next-line camelcase
            event_id: eventId,
        }));
        setLoading(true);
        try {
            const created = await dispatch(
                bulkCreateAdminUsers(payload)
            ).unwrap();
            setResult({
                ok: created.length,
                fail: urls.length - created.length,
            });
            setRaw('');
        } catch (e) {
            message.error('Ошибка при загрузке');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Title level={3}>Массовая загрузка участников</Title>
            <Paragraph>
                По одной VK-ссылке на строку. Имя и аватар подтянутся из VK API
                автоматически.
            </Paragraph>
            <Form layout="vertical" style={{ maxWidth: 640 }}>
                <Form.Item label="Event" required>
                    <Select
                        value={eventId ?? undefined}
                        onChange={(v): void => setEventId(v)}
                        options={events.map(e => ({
                            value: e.id,
                            label: e.name,
                        }))}
                        placeholder="Выбери event"
                        style={{ width: '100%' }}
                    />
                </Form.Item>
                <Form.Item label="VK-ссылки">
                    <TextArea
                        rows={12}
                        value={raw}
                        onChange={(e): void => setRaw(e.target.value)}
                        placeholder="https://vk.com/durov&#10;https://vk.com/id1"
                    />
                </Form.Item>
                <Space>
                    <Button type="primary" loading={loading} onClick={onSubmit}>
                        Загрузить
                    </Button>
                </Space>
            </Form>
            {result && (
                <Alert
                    style={{ marginTop: 16 }}
                    type={result.fail ? 'warning' : 'success'}
                    message={`Создано: ${result.ok}, ошибок: ${result.fail}`}
                />
            )}
        </div>
    );
}
